import React from "react";
import AsyncSelect from "react-select/async";
import { http } from "~/utils";

const loadOptions = (search) =>
    http
        .get("/customer-team/", { params: search ? { search } : {} })
        .then(response => {
            const data = Array.isArray(response.data)
                ? response.data
                : (response.data.results || []);
            return data.map(ct => ({ value: ct.id, label: ct.name }));
        });

/**
 * Reusable async select for customer teams.
 * Calls GET /customer-team/?search=<term> and maps { id, name } → { value, label }.
 *
 * Props:
 *   value    – current selected option ({ value, label }) or null
 *   onChange – (option) => void
 *   Any other prop is forwarded to AsyncSelect.
 */
const CustomerTeamSelect = ({ value, onChange, isMulti = false, ...rest }) => (
    <AsyncSelect
        value={value}
        isClearable
        isMulti={isMulti}
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        onChange={onChange}
        {...rest}
    />
);

export default CustomerTeamSelect;
